<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>Edit signals</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (loadingSignals) {
    <em class="fa-solid fa-spinner fa-spin"></em>
  }

  @if (useColorPalette) {
    <div class="col-auto">
      <small class="text-muted" [innerText]="colorPaletteUsedMessage"></small>
    </div>
  }

  @if (!loadingSignals) {
    <div>
      @if (signals.length > 0 && interactiveDataAnalysisConfig) {
        <ul class="list-group mb-3">
          @for (signal of signals | paginate: paginateSettings; track signal; let i = $index) {
            <li class="list-group-item">
              <scitis-edit-signal [signal]="signal" [index]="i" [id]="'edit_'+signal.id"
                [interactiveDataAnalysisConfig]="interactiveDataAnalysisConfig">
              </scitis-edit-signal>
            </li>
          }
        </ul>
      }
      <scitis-ngx-pagination [id]="paginateSettings.id"
        mainClass="justify-content-between"
        [itemsPerPage]="paginateSettings.itemsPerPage"
        [itemsPerPageOptions]="customItemsPerPageOptions"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
        (pageNumberChange)="onLoadPageNumber($event)">
      </scitis-ngx-pagination>
    </div>
  }
</div>
<scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
  (okButtonPressed)="onSave()"
  [cancelButtonText]="'Cancel' | translate"
  [okButtonText]="'Save' | translate">
</scitis-modal-footer>
